export default {
  methods: [],
  allPayMethods: []
}
